export default {
  /**
   * アンカーのstateを更新
   * data: アンカー情報 or null
   *   snapshot取得できた・・・アンカー情報
   *   snapshot取得結果0件・・・null
   */
  SET_ANCHORS(state, data) {
    // onSnapshotが0件のときはanchorsを空にする
    if (!data) {
      state.anchors.splice(0, state.anchors.length);
      return;
    }

    // 取得したアンカーに座標がなければスルーする
    if (!data.points) return;

    // 既に船舶に紐づくアンカーがあれば更新、なければ追加
    const index = state.anchors.findIndex((a) => a.hash === data.hash);
    if (index === -1) {
      state.anchors.push(data);
    } else {
      state.anchors.splice(index, 1, data);
    }
  },
  /** アンカーをstateから除外 */
  REMOVE_ANCHOR(state, hash) {
    if (!hash) return;
    state.anchors = state.anchors.filter((a) => {
      return a.hash !== hash;
    });
  },

  /*=========================================================================================
   リセット
  ==========================================================================================*/
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
};
